export { default } from './ResponsiveComponent'
